import { useEffect } from "react";

const APP_REDIRECT_URL = "https://link.belivmart.com/ejzztz26";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  zIndex: 999999,
  backgroundColor: "rgba(0, 0, 0, 0.75)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "16px",
};

const cardStyle = {
  width: "100%",
  maxWidth: "420px",
  borderRadius: "16px",
  backgroundColor: "#ffffff",
  padding: "24px",
  boxSizing: "border-box",
  textAlign: "center",
  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.2)",
};

const titleStyle = {
  margin: 0,
  fontSize: "24px",
  fontWeight: 700,
  color: "#111827",
};

const descriptionStyle = {
  margin: "12px 0 0 0",
  fontSize: "15px",
  lineHeight: 1.6,
  color: "#4b5563",
};

const buttonStyle = {
  marginTop: "20px",
  width: "100%",
  border: "none",
  borderRadius: "10px",
  padding: "12px 16px",
  backgroundColor: "#f97316",
  color: "#ffffff",
  fontSize: "16px",
  fontWeight: 600,
  cursor: "pointer",
};

export default function MobileAppOnlyPopup() {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  const handleOpenApp = () => {
    window.open(APP_REDIRECT_URL, "_self");
  };

  return (
    <div style={overlayStyle}>
      <div style={cardStyle}>
        <h2 style={titleStyle}>Use Mobile App</h2>
        <p style={descriptionStyle}>
          Belivmart is now available only on the mobile app. Please open the app
          to continue.
        </p>
        <button type="button" onClick={handleOpenApp} style={buttonStyle}>
          Open Belivmart App
        </button>
      </div>
    </div>
  );
}
